module.exports = __webpack_public_path__ + "files/86bc0e1f9cd5ad0545fc9c6e1f720ca4.png";